import * as React from 'react';
import { connect } from 'react-redux';

import Page from 'components/page/Page';
import PageNotFound from '../../../components/page/page-not-found/PageNotFound';
import SidebarPage from 'components/page/sidebar-page/SidebarPage';
import SettingsSidebar from 'modules/settings/SettingsSidebar';
import SideNavigation from 'components/side-navigation-v2/SideNavigation';

import { navigate } from 'libs/router';

import { fetchCurrentUserOrganizations } from 'modules/organizations/reducers/organizations';

import { __t } from 'utils/language';
import { getBrandProfileId } from 'utils/organization';
import { getAgencySettingsSubnavigation, mapNavigationNavItemToSideNavigationItem } from 'utils/navigation';

import type { Organization } from 'types';

type OwnProps = {
  id: number | undefined | null,
  documentTitle: string,
  renderChildren: (a: number) => React.ReactNode
};

type StateProps = {
  mapByOrganizationId: {
    [x: number]: Organization
  },
  isAdminMode: boolean
};

type DispatchProps = {
  dispatchFetchCurrentUserOrganizations: () => Promise<any>
};

type Props = OwnProps & StateProps & DispatchProps;

class BaseAgencyPage extends React.Component<Props> {
  componentDidMount() {
    const { dispatchFetchCurrentUserOrganizations } = this.props;

    dispatchFetchCurrentUserOrganizations();
  }


  getBrandAgencyProfileId() {
    const { id, mapByOrganizationId } = this.props;
    const agencyOrganization = id ? mapByOrganizationId[id] : null;

    return getBrandProfileId(agencyOrganization);
  }

  getSidebar() {
    const { id: agencyOrganizationId, isAdminMode } = this.props;

    if (isAdminMode && agencyOrganizationId) {
      return (
        <SideNavigation
          items={[
            {
              type: 'container',
              title: __t('settings_sidebar.agency_settings'),
              children: getAgencySettingsSubnavigation(agencyOrganizationId, true)
                .map(mapNavigationNavItemToSideNavigationItem)
            }
          ]}
        />
      );
    }

    return <SettingsSidebar />;
  }

  render() {
    const { id, isAdminMode, documentTitle, renderChildren } = this.props;
    const brandProfileId = this.getBrandAgencyProfileId();

    if (!id) {
      return <PageNotFound />;
    }

    if (!brandProfileId) {
      navigate.to(`/agency/${id}/create`);
      return null;
    }

    return (
      <Page
        documentTitle={documentTitle}
        subnavigationClassName="page__agency-subnavigation"
      >
        <SidebarPage
          sidebarWidth="narrow"
          scrollable={!isAdminMode}
          sidebarContent={this.getSidebar()}
        >
          {renderChildren(brandProfileId)}
        </SidebarPage>
      </Page>
    );
  }
}

const mapStateToProps = ({ organizations, router }): StateProps => ({
  isAdminMode: /^\/admin\//.test(router.location.pathname),
  mapByOrganizationId: organizations.mapByOrganizationId
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchFetchCurrentUserOrganizations: () => dispatch(fetchCurrentUserOrganizations())
});

export default connect(mapStateToProps, mapDispatchToProps)(BaseAgencyPage);
